import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useProviderProductCode from '@hooks/useProviderProductCode'

import type { ProviderProductCodeModel } from '@models/types'

const ProviderProductCodeListItem = (props: { providerProductCode: ProviderProductCodeModel }) => {
  const { providerProductCode } = props
  const { product_code } = providerProductCode

  const {
    callbacks: {
      createOrEditProviderProductCode,
    },
    serviceProduct,
  } = useProviderProductCode(providerProductCode)

  const { title } = serviceProduct || {}

  return (
    <DashboardModuleListItem
      onClick={() => createOrEditProviderProductCode()}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {product_code}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default ProviderProductCodeListItem
